import { render, staticRenderFns } from "./garden18.vue?vue&type=template&id=110e0fcf&scoped=true"
import script from "./garden18.vue?vue&type=script&lang=js"
export * from "./garden18.vue?vue&type=script&lang=js"
import style0 from "./garden18.vue?vue&type=style&index=0&id=110e0fcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110e0fcf",
  null
  
)

export default component.exports